// pages/users/DistributorsPage.jsx
import UserRolePage from './UserRolePage.jsx';
export default function DistributorsPage() {
  return <UserRolePage role="distributor" title="Distributors" accentColor="#059669"
    roleOptions={['distributor']} />;
}